import React, { Component } from "react";
import styled from "styled-components";
import Tick from "../../assets/tick.svg";
import Close from "../../assets/close.svg";
import { FormattedMessage } from "react-intl";

const Radio = styled.div`
  display: flex;
  [type="radio"]:checked,
  [type="radio"]:not(:checked) {
    position: absolute;
    left: -9999px;
  }
  [type="radio"] + label {
    margin: 2px 0;
    background-color: #f1f1f1;
    background-image: url(${Close});
    background-repeat: no-repeat;
    background-size: 8px;
    background-position: 8px 10px;
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 24px;
    padding-right: 12px;
    font-size: 11px;
    cursor: pointer;
    font-weight: bold;
    color: #000;
  }

  [type="radio"]:checked + label {
    background-color: #00ae00;
    background-image: url(${Tick});
    color: #fff;
  }
`;

class RadioField extends Component {
  onChange = e => {
    const { value } = e.currentTarget;
    const boolVal = value === "true";
    this.props.form.setFieldValue(this.props.field.name, boolVal);
  };
  render() {
    const {
      label,
      field: { name, value = false },
    } = this.props;
    return (
      <>
        <h3>
          <FormattedMessage
            id="raquet.chooseNet"
            defaultMessage="Wybierz siatkę"
          />
        </h3>
        <Radio>
          <input
            id={name + "tennis"}
            name={name}
            type="radio"
            value={true}
            onChange={this.onChange}
            checked={value}
          />
          <label htmlFor={name + "tennis"}>
            <FormattedMessage
              id="raquet.tennisNet"
              defaultMessage="Siatka do tenisa"
            />
          </label>
          <input
            id={name + "volleyball"}
            name={name}
            type="radio"
            value={false}
            onChange={this.onChange}
            checked={!value}
          />
          <label htmlFor={name + "volleyball"}>
            <FormattedMessage
              id="raquet.volleyballNet"
              defaultMessage="Siatka do siatkówki"
            />
          </label>
        </Radio>
      </>
    );
  }
}
export default RadioField;
